import { buildModelManager } from "../builder.js";
const DefaultCustomerStatsSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  delivered30days: true,
  delivered7days: true,
  delivered90days: true,
  deliveredLastMonth: true,
  deliveredLastYear: true,
  deliveredThisMonth: true,
  deliveredThisWeek: true,
  deliveredThisYear: true,
  deliveredToday: true,
  externalTurnover30days: true,
  externalTurnover7days: true,
  externalTurnover90days: true,
  externalTurnoverLastMonth: true,
  externalTurnoverLastYear: true,
  externalTurnoverThisMonth: true,
  externalTurnoverThisWeek: true,
  externalTurnoverThisYear: true,
  externalTurnoverToday: true,
  messagesCount30days: true,
  messagesCount7days: true,
  messagesCount90days: true,
  messagesCountLastMonth: true,
  messagesCountLastYear: true,
  messagesCountThisMonth: true,
  messagesCountThisWeek: true,
  messagesCountThisYear: true,
  messagesCountToday: true,
  optins30days: true,
  optins7days: true,
  optins90days: true,
  optinsLastMonth: true,
  optinsLastYear: true,
  optinsThisMonth: true,
  optinsThisWeek: true,
  optinsThisYear: true,
  optinsToday: true,
  optinsTotal: true,
  optoutCount30days: true,
  optoutCount7days: true,
  optoutCount90days: true,
  optoutCountLastMonth: true,
  optoutCountLastYear: true,
  optoutCountThisMonth: true,
  optoutCountThisWeek: true,
  optoutCountThisYear: true,
  optoutCountToday: true,
  read30days: true,
  read7days: true,
  read90days: true,
  readLastMonth: true,
  readLastYear: true,
  readThisMonth: true,
  readThisWeek: true,
  readThisYear: true,
  readToday: true,
  sales30days: true,
  sales7days: true,
  sales90days: true,
  salesLastMonth: true,
  salesLastYear: true,
  salesThisMonth: true,
  salesThisWeek: true,
  salesThisYear: true,
  salesToday: true,
  sent30days: true,
  sent7days: true,
  sent90days: true,
  sentLastMonth: true,
  sentLastYear: true,
  sentThisMonth: true,
  sentThisWeek: true,
  sentThisYear: true,
  sentToday: true,
  totalWhatsappCostInEuros30days: true,
  totalWhatsappCostInEuros7days: true,
  totalWhatsappCostInEuros90days: true,
  totalWhatsappCostInEurosLastMonth: true,
  totalWhatsappCostInEurosLastYear: true,
  totalWhatsappCostInEurosThisMonth: true,
  totalWhatsappCostInEurosThisWeek: true,
  totalWhatsappCostInEurosThisYear: true,
  totalWhatsappCostInEurosToday: true,
  turnover30days: true,
  turnover7days: true,
  turnover90days: true,
  turnoverLastMonth: true,
  turnoverLastYear: true,
  turnoverThisMonth: true,
  turnoverThisWeek: true,
  turnoverThisYear: true,
  turnoverToday: true,
  updatedAt: true
};
const modelApiIdentifier = "customerStats";
const pluralModelApiIdentifier = "customerStatss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCustomer",
    findByField: "customerId",
    findByVariableName: "customerId",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCustomer",
    findByField: "customerId",
    findByVariableName: "customerId",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerStatsSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCustomerStats",
    operationReturnType: "CreateCustomerStats",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      customerStats: { required: false, type: "CreateCustomerStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerStatsSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCustomerStats",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateCustomerStatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomerStatsSelection
  },
  {
    type: "action",
    operationName: "updateCustomerStats",
    operationReturnType: "UpdateCustomerStats",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      customerStats: { required: false, type: "UpdateCustomerStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerStatsSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCustomerStats",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateCustomerStatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomerStatsSelection
  },
  {
    type: "action",
    operationName: "deleteCustomerStats",
    operationReturnType: "DeleteCustomerStats",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCustomerStats",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCustomerStats",
    operationReturnType: "UpsertCustomerStats",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      customerStats: { required: false, type: "UpsertCustomerStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCustomerStatsResult": { hasReturnType: false },
      "... on UpdateCustomerStatsResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerStatsSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCustomerStats",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertCustomerStatsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCustomerStatsSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "customerStatsGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CustomerStatsManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCustomerStatsSelection,
  operations
);
export {
  CustomerStatsManager,
  DefaultCustomerStatsSelection
};
//# sourceMappingURL=CustomerStats.js.map
